<template>
  <esg-table-without-meta :items="items"
                          :fields="fields"
                          max-height="300px"
                          size="sm"
                          class="mt-3">
    <template #thead-top>
      <tr>
        <th colspan="4"><span>법인 정보</span></th>
        <th colspan="4"><span>제품 정보</span></th>
        <th colspan="4"><span>단위제품당 원재료 투입량</span></th>
        <th colspan="2"><span>연간 생산량</span></th>
        <th colspan="2"><span>배출량</span></th>
      </tr>
    </template>
  </esg-table-without-meta>
</template>
<script>
import EsgBaseTable from "@/components/esg/base/EsgBaseTable.vue";
import EsgTableWithoutMeta from "@/components/esg/base/EsgTableWithoutMeta.vue";

export default {
  props: {
    year: {
      type: Number
    },
    product: {
      type: Object,
    },
  },
  components: {
    EsgTableWithoutMeta,
  },
  watch: {
    product: {
      immediate: true,
      deep: true,
      handler() {
        this.fetchData()
      }
    },
    year: {
      immediate: true,
      handler() {
        this.fetchData()
      }
    }
  },
  methods: {
    async fetchData() {
      if (!this.product || !this.product.productFamilyCode || !this.product.productCode || !this.product.name) return;
      if (!this.year) return;

      try {
        this.loading = true;

        let args = [{
          years: [this.year],
          productFamilies: [this.product.productFamilyCode],
          products: [this.product.productCode],
        }];

        let data = new FormData()
        data.append('path', 'esg/lca/material_detail/main');
        data.append('json', JSON.stringify(args));

        this.abortController = new AbortController();
        let response = await axios.post('esg/lca/run/python/chart-data', data, {
          headers: { Authorization: accessToken() },
          signal: this.abortController.signal
        });

        // If there is no data, return
                if (!response.data.data) {
          this.series = [];
          return;
        }


        // Parse JSON data
        let chartData = JSON.parse(response.data.data)[0].data;

        // Filter out the data in the past
        let items = []

        let prevIdx = -1
        let currIdx = -1
        let currHeader = null
        let total = 0
        let totalPerProduction = 0
        chartData.forEach(row => {
          // Current index is the production ID of the row
          currIdx = row.production_id

          // When a new group starts
          if (currIdx !== prevIdx) {
            // Create a new row
            let newRow = Object.assign({}, row)
            newRow.material_input_id = '-'
            newRow.material_input_name = '-'
            newRow.material_input_amount = '-'
            newRow.material_input_unit = '-'
            newRow.carbon_emission_amount = 0
            newRow.carbon_emission_per_production_amount = 0

            // Push it to the new array
            items.push(newRow)
            prevIdx = currIdx

            // Add GHG emissions to totals and change header
            if (currHeader) {
              total += currHeader.carbon_emission_amount
              totalPerProduction += currHeader.carbon_emission_per_production_amount
            }
            currHeader = newRow
          }

          // Push the current row
          row.product_amount = '-'
          row.product_unit = '-'
          currHeader.carbon_emission_amount += row.carbon_emission_amount
          currHeader.carbon_emission_per_production_amount += row.carbon_emission_per_production_amount
          items.push(row)
        })

        // For the last header, add GHG emissions to totals
        if (currHeader) {
          total += currHeader.carbon_emission_amount
          totalPerProduction += currHeader.carbon_emission_per_production_amount
        }

        this.items = items
        this.total = total
        this.totalPerProduction = totalPerProduction

        this.$emit('totalCalculated', total, totalPerProduction)
      } catch (error) {
        await this.showError(error)
      }
    },
  },
  data() {
    return {
      items: [],
      fields: [
        {
          name: "corporation_code",
          label: "법인 코드",
          list: true,
          sortable: true,
        },
        {
          name: "corporation_name",
          label: "법인",
          list: true,
          sortable: true,
          filtered: true,
        },
        {
          name: "business_location_code",
          label: "사업장 코드",
          list: true,
          sortable: true,
        },
        {
          name: "business_location_name",
          label: "사업장",
          list: true,
          sortable: true,
          filtered: true,
        },
        {
          name: "product_family_code",
          label: "제품군 코드",
          list: true,
        },
        {
          name: "product_family_name",
          label: "제품군",
          list: true,
        },
        {
          name: "product_code",
          label: "제품 코드",
          list: true
        },
        {
          name: "product_name",
          label: "제품명",
          list: true
        },
        {
          name: "material_input_id",
          label: "원료 코드",
          list: true,
          filtered: true
        },
        {
          name: "material_input_name",
          label: "원료명",
          list: true,
          filtered: true
        },
        {
          name: "material_input_amount",
          label: "투입량",
          list: true,
          type: 'Number'
        },
        {
          name: "material_input_unit",
          label: "투입 단위",
          list: true
        },
        {
          name: "product_amount",
          label: "제품 생산량",
          list: true,
          sortable: true,
          type: 'Number'
        },
        {
          name: "product_unit",
          label: "생산 단위",
          list: true,
        },
        {
          name: "carbon_emission_per_production_amount",
          label: "단위 배출량\n(tCO2e)",
          formatter: val => this.formatNumber(val),
          list: true,
          type: 'Number',
          sortable: true
        },
        {
          name: "carbon_emission_amount",
          label: '연간 배출량\n(tCO2e)',
          formatter: val => this.formatNumber(val),
          list: true,
          type: 'Number',
          sortable: true
        },
      ]
    }
  },
}
</script>